<template>
  <transition appear name="slideFromBottom">
    <div
        class="cookie cookie__bar cookie__bar--bottom"
        v-if="isOpen">
      <div class="cookie__bar__wrap">
        <div class="cookie__bar__content">
          <slot name="message">
            Iffent veebilehel kasutatakse küpsiseid, et pakkuda parimat kasutuskogemust, isikupärastamist ja analüütika.
          </slot>
        </div>

        <button
            @click="accept"
            class="m-1 text-white bg-blue-500 btn" >
          <slot name="acceptContent">Nõustun</slot>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import * as tinyCookie from 'tiny-cookie';

export default {
  name: 'cookie-accept',
  props: {
    //
  },
  data () {
    return {
      status: null,
      supportsLocalStorage: true,
      isOpen: false,
    };
  },
  computed: {
    //
  },
  mounted () {
    this.checkLocalStorageFunctionality();
    this.init();
  },
  methods: {
    init () {
      let visitedType = this.getCookieStatus();

      if (
          visitedType &&
          (visitedType === 'accept')
      ) {
        this.isOpen = false;
      }

      if (!visitedType) {
        this.isOpen = true;
      }

      this.status = visitedType;
      this.$emit('status', visitedType);
    },
    checkLocalStorageFunctionality () {
      // Check for availability of localStorage
      try {
        const test = '__cookie-accept-check-localStorage';
        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
      } catch (e) {
        console.error('Local storage is not supported, falling back to cookie use');
        this.supportsLocalStorage = false;
      }
    },
    setCookieStatus (type) {
      if (this.supportsLocalStorage) {
        if (type === 'accept') {
          localStorage.setItem(`cookie-accept`, 'accept');
        }
      } else {
        if (type === 'accept') {
          tinyCookie.set(`cookie-accept`, 'accept');
        }
      }
    },
    getCookieStatus () {
      if (this.supportsLocalStorage) {
        return localStorage.getItem(`cookie-accept`);
      } else {
        return tinyCookie.get(`cookie-accept`);
      }
    },
    accept () {
      this.setCookieStatus('accept');

      this.status = 'accept';
      this.isOpen = false;
      this.$emit('clicked-accept');
    },
    removeCookie () {
      localStorage.removeItem(`cookie-accept`);
      this.status = null;
      this.$emit('removed-cookie');
    },
  },
};
</script>

<style lang="scss">
$lighter-grey: #eee;
$light-grey: #ddd;
$grey: darken($light-grey, 9%);
$green: #009FB7;
$dark-green: darken($green, 8%);
$white: #fff;
$off-white: darken($white, 2%);
$black: #333;
$transition: all 0.2s ease;

.cookie {
  &__bar {
    -ms-overflow-style: none;
    position: fixed;
    overflow: hidden;
    box-sizing: border-box;
    z-index: 9999;
    width: 100%;
    background: $lighter-grey;
    padding: 20px 20px;
    align-items: center;
    box-shadow: 0 -4px 4px rgba($grey, 0.05);
    border-top: 1px solid $light-grey;
    border-bottom: 1px solid $light-grey;
    font-size: 1rem;
    font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu,
    Cantarell, “Fira Sans”, “Droid Sans”, “Helvetica Neue”, Arial, sans-serif;
    line-height: 1.5;

    &--bottom {
      bottom: 0;
      left: 0;
      right: 0;
    }

    &__wrap {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
      width: 100%;

      @media (min-width: 768px) {
        flex-direction: row;
      }
    }

    &__content {
      margin-right: 0;
      margin-bottom: 20px;
      max-height: 103px;
      overflow: auto;
      width: 100%;
      -ms-flex: 1 1 auto;

      @media (min-width: 768px) {
        margin-right: auto;
        margin-bottom: 0;
      }
    }
  }
}

.slideFromBottom-enter,
.slideFromBottom-leave-to {
  transform: translate(0px, 10em);
}

.slideFromBottom-enter-to,
.slideFromBottom-leave {
  transform: translate(0px, 0px);
}

.slideFromBottom-enter-active {
  transition: transform 0.2s ease-out;
}

.slideFromBottom-leave-active {
  transition: transform 0.2s ease-in;
}
</style>